import { SidebarState } from 'editor/src/store/editorModules/sidebar/types';

const selectPreviousTabReducer = (state: SidebarState) => {
  state.activeTabIndex = state.lastNonSystemTabIndex;
  state.payload = undefined;
};

export default selectPreviousTabReducer;
